// client/src/coms/conversations/recentConversations.js
// Which conversations you visited and when: conversation ids (the same ids as conversation tabs,
// "c:<server>:<channel>" and "d:<thread>") with a timestamp, per account, in this browser. No names or message
// content are stored here; everything shown is looked up live from servers, DMs and read states.
const MAX = 40;
const keyFor = (uid) => `vox:recents:${uid || 'anon'}`;

export function readRecents(uid) {
  try {
    const raw = JSON.parse(window.localStorage.getItem(keyFor(uid)) || '[]');
    return Array.isArray(raw) ? raw.filter((r) => r && typeof r.id === 'string' && /^(c|d):/.test(r.id) && Number.isFinite(r.at)).slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function recordRecent(uid, id, at = Date.now()) {
  if (!id || !/^(c|d):/.test(id)) return [];
  const next = [{ id, at }, ...readRecents(uid).filter((r) => r.id !== id)].slice(0, MAX);
  try {
    window.localStorage.setItem(keyFor(uid), JSON.stringify(next));
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent('vox-recents-changed'));
  } catch {}
  return next;
}

export function forgetRecent(uid, id) {
  const next = readRecents(uid).filter((r) => r.id !== id);
  try {
    window.localStorage.setItem(keyFor(uid), JSON.stringify(next));
    window.dispatchEvent(new CustomEvent('vox-recents-changed'));
  } catch {}
  return next;
}
